<template>
  <div id="modal" class="active">
    <div class="modal_pop active px-0">
      <div class="modal_pop_inner px-4">
        <div class="pb-0 header-box" style="text-align: center">
          <h4>부고 전송</h4>
          <v-divider class="my-4"></v-divider>
        </div>

        <div class="mb-4 sendObituaryConatainer">
          <div class="d-flex inputContainer" style="align-items: center;">
            <label for="sanjuSelect" class="label">상주 선택</label>

            <select v-model="member" id="sanjuSelect">
              <option
                v-for="member in ObituaryMembers"
                :key="member.id"
                :value="member"
                >{{ member.memberName }}</option
              >
            </select>
          </div>
          <div class="d-flex inputContainer">
            <span class="label">상주 표시</span>
            <input
              type="radio"
              name="상주개별"
              value="only"
              id="showOnly"
              v-model="showType"
            />
            <label for="showOnly">개별</label>

            <input
              type="radio"
              name="상주단체"
              value="all"
              id="showAll"
              v-model="showType"
            />
            <label for="showAll">단체</label>
          </div>

          <div class="d-flex inputContainer">
            <span class="label">계좌번호 표시</span>
            <input
              type="radio"
              name="부의금개별"
              value="only"
              id="accountShowOnly"
              v-model="accountShowType"
            />
            <label for="accountShowOnly">개별</label>

            <input
              type="radio"
              name="부의금단체"
              value="all"
              id="accountShowAll"
              v-model="accountShowType"
            />
            <label for="accountShowAll">단체</label>
          </div>
        </div>

        <h4
          style="font-weight: 700;
    font-size: 16px;
    color: #414141;"
        >
          미리보기
        </h4>
        <v-divider class="mt-1 mb-2"></v-divider>
        <div style="overflow-y: auto;height: 200px;">
          <p class="mb-0">[부고알림]</p>
          <p>{{ messageTxt }}</p>
          <p v-html="messageTxt2.replace(/\n/g, '<br />')"></p>
          <p>{{ messageTxt3 }}</p>
        </div>

        <div style="display: flex; gap:16px">
          <button class="send_button mt-4" @click="sendMsg('문자')">
            문자 전송
          </button>
          <button class="send_button mt-4" @click="sendMsg('알림톡')">
            알림톡 전송
          </button>
        </div>

        <button class="send_button mt-4" @click="sendMsgDirect">
          메시지 앱 열기
        </button>
        <div class="button__wraps">
          <button class="cancel" @click="close">닫기</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { makeSmsName } from "../../utils/sms";
export default {
  name: "ObituarySendModal",
  props: ["sendObituary"],

  data() {
    return {
      member: null,
      showType: "only",
      accountShowType: "only"
    };
  },
  computed: {
    ObituaryMembers() {
      return this.sendObituary && this.sendObituary.ObituaryMembers;
    },
    messageTxt() {
      if (!this.member || !this.sendObituary) return "";
      const { memberName, memberType } = this.member;
      const { name, gender, dieType } = this.sendObituary;
      if (this.showType === "only") {
        return `${makeSmsName(
          this.member && memberType,
          gender,
          this.member && memberName,
          name
        )}님께서 ${dieType} 하셨기에 아래와 같이 부고를 전해 드립니다.`;
      }
      return `故 ${name}님께서 ${dieType} 하셨기에 아래와 같이 부고를 전해 드립니다.`;
    },
    messageTxt2() {
      if (!this.member || !this.sendObituary) return "";

      const members = [];
      let memberListString = "";

      const sortMembers = this.sendObituary.ObituaryMembers.sort((a, b) => {
        if (a.typeOrder === b.typeOrder) {
          return a.order - b.order;
        }
        return a.typeOrder - b.typeOrder;
      });

      sortMembers.forEach(v => {
        const index = members.findIndex(arg => arg.type === v.memberType);
        if (v.syncFlag) {
          if (index !== -1) {
            members[index].value += `, ${v.memberName}`;
          } else {
            if (v.memberName) {
              members.push({
                type: v.memberType,
                value: v.memberName
              });
            }
          }
        }
      });
      members.forEach(v => {
        memberListString += `${v.type}: ${v.value} \n`;
      });

      const messageTxt2 = `■부고■
부고장 링크`;

      if (this.showType === "only") {
        return messageTxt2;
      }
      return `상주정보
${memberListString}
${messageTxt2}`;
    },

    messageTxt3() {
      if (!this.sendObituary) return "";
      const {
        CorpId,
        DirectorId,
        FuneralId,
        Corp,
        Director,
        Funeral
      } = this.sendObituary;

      const basicMsg = "본 메세지는 유가족들의 마음을 담아 ";

      if ((CorpId && DirectorId) || (CorpId && !DirectorId)) {
        return basicMsg + Corp?.name + "에서 제작된 모바일 부고장입니다.";
      } else if (!CorpId && DirectorId) {
        return (
          basicMsg +
          Director?.name +
          " 장례지도사가 제작한 모바일 부고장입니다."
        );
      } else if (FuneralId) {
        return basicMsg + Funeral?.name + "에서 제작된 모바일 부고장입니다.";
      }
    },

    smsBody() {
      const smsMessage = `[부고알림]
${this.messageTxt}

${this.messageTxt2}

${this.messageTxt3}`;

      return smsMessage;
    }
  },
  mounted() {
    this.member = this.ObituaryMembers[0];
  },
  methods: {
    close() {
      this.$emit("close");
    },

    async sendMsg(msgType) {
      if (!this.sendObituary || !this.sendObituary.id) {
        alert(
          "부고장 링크 생성에 실패하였습니다. 새로고침 후 다시 시도해주십시오"
        );
        return;
      }

      const data = await this.$store.dispatch(
        "REQUEST_ENCODE",
        this.sendObituary.id
      );

      if (!data.result) {
        alert("부고장 링크 생성에 실패하였습니다");
        return;
      }

      const encodeId = data.str;

      const url = `${
        this.accountShowType === "only"
          ? `${process.env.VUE_APP_OBITUARY_BASEURL}/?memberId=${this.member.id}`
          : `${process.env.VUE_APP_OBITUARY_BASEURL}/?id=${encodeId}`
      }`;

      const smsBody = this.smsBody.replace("부고장 링크", url);

      const parameter = {
        id: this.member.id,
        msgType,
        smsBody,
        showType: this.showType,
        accountShowType: this.accountShowType
      };
      this.$store.dispatch("REQUEST_OBITUARY_ONLY_SEND", parameter);
    },

    async sendMsgDirect() {
      if (!this.member.memberPhone) {
        alert("해당 상주의 휴대폰 번호가 입력되어 있지 않습니다");
        return;
      }

      if (!this.sendObituary || !this.sendObituary.id) {
        alert(
          "부고장 링크 생성에 실패하였습니다. 새로고침 후 다시 시도해주십시오"
        );
        return;
      }

      const encodeId = encodeURIComponent(this.$route.query.id) || null;

      if (!encodeId) {
        alert("부고장 링크 생성에 실패하였습니다");
        return;
      }

      const url = `${
        this.accountShowType === "only"
          ? `${process.env.VUE_APP_OBITUARY_BASEURL}/?memberId=${this.member.id}`
          : `${process.env.VUE_APP_OBITUARY_BASEURL}/?id=${encodeId}`
      }`;

      const encodeUrl = url
        .replace(/%20/g, "JR_PLUS")
        .replace(/ /g, "JR_PLUS")
        .replace(/\+/g, "JR_PLUS");

      const smsBody = this.smsBody.replace("부고장 링크", encodeUrl);

      let realSmsMessage = smsBody.replace(/(\n|\r\n)/g, "%0a");
      realSmsMessage = encodeURIComponent(smsBody);

      let varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기

      let phoneType = "";
      if (varUA.indexOf("android") > -1) {
        //안드로이드
        phoneType = "android";
      } else if (
        varUA.indexOf("iphone") > -1 ||
        varUA.indexOf("ipad") > -1 ||
        varUA.indexOf("ipod") > -1 ||
        varUA.indexOf("mac") > -1
      ) {
        //IOS
        phoneType = "ios";
      } else {
        //아이폰, 안드로이드 외
        phoneType = "other";
      }

      const href = `sms:${this.member.memberPhone}${
        phoneType == "ios" ? "&" : "?"
      }body=${realSmsMessage}`;

      location.href = href;
    }
  }
};
</script>

<style>
#modal {
  display: none;
}
#modal.active {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  margin: auto;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px 24px;
}

.modal_pop {
  display: none;
}

/*modal_pop */
.modal_pop.active {
  display: block;
}
.modal_pop {
  max-width: 380px;
  height: 600px;

  position: fixed;
  top: 0;
  bottom: 0;
  left: 20px;
  right: 20px;
  margin: auto;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  border-radius: 6px;

  padding: 0px 16px;

  background-color: #fff;
  z-index: 100;
}

.modal_pop .modal_pop_inner .header-box {
  width: 100%;

  padding: 27px 8px;

  font-family: var(--noto3);
  font-weight: 700;
  font-size: 18px;
  color: #212121;
}
.modal_pop .modal_pop_inner p {
  font-family: var(--noto3);
  font-weight: 700;
  font-size: 14px;
  color: #666666;
}

.modal_pop .modal_pop_inner .preview-box {
  width: 100%;

  padding: 0px 12px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  border-bottom: 1px solid rgba(221, 221, 221, 0.7);
}
.modal_pop .modal_pop_inner .preview-box .member-info {
  display: flex;
  align-items: center;
}
.modal_pop .modal_pop_inner .preview-box span {
  margin-right: 8px;

  font-weight: 600;
  font-size: 16px;
  text-align: center;
  color: #666666;
}
.modal_pop .modal_pop_inner .preview-box h4 {
  margin: 0;
  font-weight: 400;
  font-size: 18px;
  color: #222222;
}
.modal_pop .modal_pop_inner .preview-box button {
  font-weight: 500;
  font-size: 16px;
  color: #988a84;
}
.modal_pop .modal_pop_inner .button__wraps {
  width: 100%;

  position: absolute;
  left: 0px;
  bottom: 0px;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;

  padding: 0px !important;
}
.modal_pop .modal_pop_inner .button__wraps button {
  width: 100%;
  height: 46px;

  border-radius: 0px 0px 6px 6px;

  font-weight: 700;
  font-size: 16px;
  color: #ffffff;

  background: var(--main-color);
}

.modal_pop button.btn_jangji_colse {
  position: absolute;
  top: 30px;
  right: 40px;
  width: 24px;
  height: 23px;
  background: url("../../assets/images/common_2/ico/close_btn_black.png")
    no-repeat 0 0;
  background-size: contain;
  text-indent: -10000px;
}
.modal_pop table {
  width: 578px;
}
.modal_pop table td {
  padding-top: 10px;
}
.modal_pop table td:nth-child(3) {
  text-align: center;
}
.modal_pop table .input01 {
  width: 428px;
  height: 37px;
  border: 1px solid #e1e1e1;
  color: #3f4044;
}
.modal_pop .jangji_turn {
  width: 74px;
  height: 39px;
  border: 1px solid #3f4044;
  border-radius: 2px;
  font-weight: 600;
  letter-spacing: -1.2px;
}
.modal_pop .jangji_del {
  width: 38px;
  height: 39px;
  border: 1px solid #3f4044;
  border-radius: 2px;
  background: url("../../assets/images/common_2/ico/jangji_icon_del.png")
    no-repeat center center;
  text-align: center;
}
.modal_pop .jangji_plus {
  width: 38px;
  height: 39px;
  border: 1px solid #3f4044;
  border-radius: 2px;
  background: url("../../assets/images/common_2/ico/jangji_icon_plus.png")
    no-repeat center center;
}
.modal_pop .btn_jangi_area {
  position: absolute;
  bottom: 0;
  left: 74px;
  text-align: center;
}
.modal_pop .btn_jangi_area .btn_confirm {
  width: 203px;
  height: 49px;
  background-color: #4a2a0a;
  color: #fff;
  margin-right: 11px;
}
.modal_pop .btn_jangi_area .btn_cancel {
  width: 203px;
  height: 49px;
  border: 1px solid #999999;
}
.modal_pop .btn_up {
  width: 388px;
  height: 39px;
  border: 1px solid #6f4f2a;
  margin: 10px 10px 0 0;
  background: #fff url("../../assets/images/common_2/ico/icon_up.png") no-repeat
    356px 10px;
}
.modal_pop .btn_up .btn_up_txt {
  position: relative;
  color: #6f4f2a;
  text-align: left;
  padding-left: 10px;
  letter-spacing: -0.7px;
}

.sendObituaryConatainer .label {
  font-family: var(--noto3);
  font-weight: 700;
  font-size: 14px;
  color: #666666;
  margin: 8px 8px 0px 0px;
  width: 85px;
  flex-shrink: 0;
}
.sendObituaryConatainer .inputContainer {
  align-items: flex-end;
  gap: 8px;
}
.sendObituaryConatainer .inputContainer input[type="radio"] {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  border-radius: 50%;
  width: 16px;
  height: 16px;

  border: 1px solid #999;

  position: relative;
}
.sendObituaryConatainer .inputContainer input[type="radio"]:checked {
  background: none;
  border: 5px solid #ac9286;
}
#sanjuSelect {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 100%;
  border: 1px solid #ac9286;
  border-radius: 12px;
  padding: 6px 8px;
  margin-top: 2px;
  background: url("../../assets/icons/master/arrow_down.svg") no-repeat 95% 50%;
}

.send_button {
  width: 100%;
  border: 1px solid #ac9286;
  border-radius: 12px;
  padding: 6px 8px;
  color: #ac9286;
  font-family: var(--noto3);
  font-weight: 700;
  font-size: 14px;
}
</style>
